import { DefaultForm } from '@shop/frontend/web/js/classes/form/DefaultForm';

export class LoginForm extends DefaultForm {
  constructor(form) {
    super();
    this.$form = form;
    this.sphereChanged = false;
  }

  init() {
    $(this.$form).on('afterValidate', (event, messages, errorAttributes) => {
      this.errors = [];
      if (messages) {
        Object.keys(messages).forEach((key) => {
          const keyLast = key.split('-')[1];
          if (messages.errors) {
            Object.keys(messages.errors).forEach((error) => {
              if (error === keyLast) {
                this.errors.push(key);
              }
            });
          } else if (messages[key].length) {
            this.errors.push(key);
          }
        });
      }
      this.checkFields(this.$form);
    });

    const formReCaptchaInput = document.querySelector('#login-form-recaptcha');
    $(formReCaptchaInput).on('change', () => {
      this.checkFields(this.$form);
    });
  }

  checkFields($form) {
    const $submitButton = $form.querySelector('.js-form-submit-button');
    const $fields = $form.querySelectorAll('.js-required-field');
    const $checkboxFields = $form.querySelectorAll('.js-form-checkbox');
    const formReCaptchaInput = document.querySelector('#login-form-recaptcha');

    const isValid = formReCaptchaInput
      ? this.checkInputs($fields) && this.checkCheckboxes($checkboxFields) && $(formReCaptchaInput).val()
      : this.checkInputs($fields) && this.checkCheckboxes($checkboxFields);

    isValid
      ? this.activateSubmitButton($submitButton)
      : this.disableSubmitButton($submitButton);
  }
}
